import { differenceWith, without, merge } from 'lodash';

import { formatAnswers, updateAnswers } from '../../lib/answers';
import { isAnsweredCorrectlyOnFirstTry } from '../../services/activities';
import { GRAPHIC_ORGANIZER_ACTION_TYPES, READING_ACTION_TYPES } from '../actions/action_types';

const allowAnotherAttempt = currentAnswer => !currentAnswer.correct && currentAnswer.attempts < 2;

export const initialState = {
  questions: {},
  answeredQuestions: [],
  activeQuestionsIds: [],
  currentQuestionId: null,
  seenQuestions: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case READING_ACTION_TYPES.SET_BOOK_STATE: {
      const { graphicOrganizerAnswers } = payload;

      return { ...state, answeredQuestions: formatAnswers(graphicOrganizerAnswers, 'graphicOrganizerId') };
    }

    case GRAPHIC_ORGANIZER_ACTION_TYPES.SET_QUESTIONS:
      return {
        ...state,
        questions: payload.map((question, index) => merge(question, { questionIndex: index + 1 })),
      };

    case GRAPHIC_ORGANIZER_ACTION_TYPES.ACTIVATE: {
      const { graphicOrganizerIds, lastAnswers } = payload;
      const newGraphicOrganizerIds = differenceWith(
        graphicOrganizerIds,
        lastAnswers,
        (organizerId, answer) => organizerId === answer.graphicOrganizerId && !allowAnotherAttempt(answer),
      );
      return {
        ...state,
        activeQuestionsIds: Array.from(new Set([...state.activeQuestionsIds, ...newGraphicOrganizerIds])),
      };
    }

    case GRAPHIC_ORGANIZER_ACTION_TYPES.ANSWER: {
      const { graphicOrganizerId, correct, attempts, bookAttempts } = payload;
      const newAnswer = {
        graphicOrganizerId,
        correct,
        attempts,
        bookAttempts,
      };

      const currentIds = [...state.activeQuestionsIds];
      const currentAnswers = updateAnswers(state.answeredQuestions, 'graphicOrganizerId', newAnswer);

      return {
        ...state,
        activeQuestionsIds: !allowAnotherAttempt({ correct, attempts })
          ? without(currentIds, graphicOrganizerId)
          : state.activeQuestionsIds,
        answeredQuestions: currentAnswers,
      };
    }

    case GRAPHIC_ORGANIZER_ACTION_TYPES.OPEN: {
      const seenQuestions = new Set([...state.seenQuestions, payload.graphicOrganizerId || state.currentQuestionId]);
      return {
        ...state,
        currentQuestionId: payload.graphicOrganizerId || state.currentQuestionId,
        seenQuestions,
      };
    }

    case GRAPHIC_ORGANIZER_ACTION_TYPES.CLOSE:
      return { ...state, currentQuestionId: null };

    case READING_ACTION_TYPES.SHOW_UNANSWERED_QUESTIONS:
      return {
        ...state,
        answeredQuestions: state.answeredQuestions.filter(isAnsweredCorrectlyOnFirstTry),
        activeQuestionsIds: [],
      };

    case READING_ACTION_TYPES.CLOSE_BOOK:
      return initialState;

    default:
      return state;
  }
};
